import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FACE_BY_ID } from "~/lib/faces";
import { useScene } from "~/lib/store";

export function HoveredHint() {
  const { pathname } = useLocation();
  const hoveredId = useScene((s) => s.hoveredFaceId);
  const setHovered = useScene((s) => s.setHoveredFace);
  const onHome = pathname === "/";

  // If we leave home with a stale hover state, clear it. Pointer-out
  // on the cube doesn't fire reliably when click-navigation unmounts
  // the canvas before the leave event lands.
  useEffect(() => {
    if (!onHome && hoveredId) {
      setHovered(null);
    }
  }, [onHome, hoveredId, setHovered]);

  if (!onHome || !hoveredId) return null;
  const face = FACE_BY_ID[hoveredId];

  return (
    <div
      className="pointer-events-none fixed bottom-6 left-1/2 z-40 -translate-x-1/2 rounded-full border border-jg-border bg-jg-bg-soft/80 px-4 py-2 text-sm shadow-xl backdrop-blur-md sm:bottom-10"
      role="status"
      aria-live="polite"
    >
      <span
        className="font-display font-semibold"
        style={{ color: face.themeColor }}
      >
        {face.label}
      </span>
      <span className="ml-2 text-jg-fg-muted">{face.blurb}</span>
      <span className="ml-3 hidden text-xs text-jg-fg-muted sm:inline">
        Click to enter →
      </span>
    </div>
  );
}
